import { type PropsWithChildren } from 'react'
import {
  PlaybackProvider,
  usePlaybackData,
} from 'components/PlaybackProvider/PlaybackContext'

function HoverPlaybackArea({ children }: PropsWithChildren) {
  const { setPlaybackSuspended } = usePlaybackData()

  return (
    <div
      onMouseEnter={() => setPlaybackSuspended(false)}
      onMouseLeave={() => setPlaybackSuspended(true)}
    >
      {children}
    </div>
  )
}

export default function HoverPlayback({ children }: PropsWithChildren) {
  return (
    <PlaybackProvider initiallySuspended>
      <HoverPlaybackArea>{children}</HoverPlaybackArea>
    </PlaybackProvider>
  )
}
